import { getIsWidgetSupported, postRequestWidgetCreation } from "apis/widgetApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { oidc } from "services/oidcService";
import {
  IS_WIDGET_SUPPORTED_REQUESTED,
  IS_WIDGET_SUPPORTED_REQUEST_FAILED,
  receiveIsWidgetSupported,
  receiveWidgetCreation,
  WIDGET_CREATION_REQUESTED,
  WIDGET_CREATION_REQUEST_FAILED
} from "./widgetActions";

export function* doRequestWidgetCreation(action, requestInfo) {
  const userEmail = yield call(oidc.getCurrentUserEmail);
  yield call(postRequestWidgetCreation, requestInfo, action.vendorId, userEmail, action.albumId, action.id);
  yield put(receiveWidgetCreation(action.id));
}

export function* doRequestIsWidgetSupported(action, requestInfo) {
  const order = yield call(getIsWidgetSupported, requestInfo, action.id);
  yield put(receiveIsWidgetSupported(action.id, order.isWidgetSupported));
}

export function* watchWidget() {
  yield all([
    takeEvery(WIDGET_CREATION_REQUESTED, doCall(doRequestWidgetCreation, WIDGET_CREATION_REQUEST_FAILED)),
    takeEvery(IS_WIDGET_SUPPORTED_REQUESTED, doCall(doRequestIsWidgetSupported, IS_WIDGET_SUPPORTED_REQUEST_FAILED))
  ]);
}
